<template>
    <div style="width:90%">
        <el-button type="primary" size="small" style="margin:1%" round @click="editialogVisible()">新增员工</el-button>
        <el-table :data="roleData.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
            <el-table-column prop="id" label="ID" align="center" width="80"> </el-table-column>
            <el-table-column prop="userId" label="关联会员" align="center" width="80"> 
                <!-- <template slot-scope="scope">
                    <span >{{scope.row.userId}}</span>
                    <span >{{scope.row.userId}}</span>
                </template> -->
            </el-table-column>
            <el-table-column prop="username" label="账号"  max-width="150" align="center"> </el-table-column>
			<el-table-column prop="realname" label="真实姓名" max-width="150" align="center"> </el-table-column>
			<el-table-column prop="phone" label="手机号" max-width="150" align="center"> </el-table-column>
            <el-table-column prop="jobTitle" label="岗位" max-width="150" align="center"> 
                <template slot-scope="scope">
                    <span v-if="scope.row.jobTitle">{{scope.row.jobTitle}}</span>
                    <span v-else>未设置</span>
                </template>
            </el-table-column>
            <el-table-column prop="levelName" label="级别" max-width="150" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.levelName">{{scope.row.levelName}}</span>
                    <span v-else>未设置</span>
                </template>
            </el-table-column>
			<el-table-column prop="supplierName" label="关联供应商" max-width="150" align="center" v-if="storeId==0">
			</el-table-column>
			<el-table-column prop="roleName" label="角色名称" max-width="150" align="center">
			</el-table-column>
            <el-table-column prop="createDate" label="创建时间" max-width="150" align="center">
            </el-table-column>
            <el-table-column  label="操作"  fixed="right" align="center" max-width="150">
                <template slot-scope="scope">
    　　　　　　    <el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
    　　　　　　    <el-button size="small" type="text" @click="resetPassword(scope.row.id)">重置密码</el-button>
    　　　　　　    <el-button size="small" type="text" @click="toDeleteRole(scope.row.id)">删除</el-button>
    　　　　　　    <el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">授权</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination style="margin: 20px;" background :current-page="roleData.pageNum" @current-change="pageChange"
            layout="total, sizes, prev, pager, next, jumper" :total="roleData.total" @size-change="handleSizeChange">
        </el-pagination>


        <!-- 新增、 -->
        <el-dialog style="float:rigin" :title="titleName" :visible.sync="editDialogVisible" width="700px" 
        :close-on-click-modal="false">
            <div class="app-container" style="padding-right:40px;">
                <el-form ref="form" :model="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">
                    <el-form-item  :label-width="formLabelWidth" label="账号:">
                        <el-input v-model="form.username" placeholder="请输入账号" />
                    </el-form-item>
                    <el-form-item  v-if="titleName=='添加'"  :label-width="formLabelWidth" label="登录密码:">
                        <el-input v-model="form.password" placeholder="请输入登录密码" show-password/>
                    </el-form-item>
					<el-form-item :label-width="formLabelWidth" label="真实姓名:">
					    <el-input v-model="form.realname" placeholder="请输入真实姓名" />
					</el-form-item>
					<el-form-item :label-width="formLabelWidth" label="手机号:">
					    <el-input v-model="form.phone" placeholder="请输入手机号"/>
                        <span v-if="storeId > 0 &&titleName=='添加'"  style="width:320px;margin-left:20px;">
                            系统将为此员工创建APP账号
                        </span>
					</el-form-item>
                    <el-form-item label="选择岗位">
						<el-select v-model="form.jobId" @change="postChange" style="width:600px;">
							<el-option v-for="item in KxList" :key="item.id" :value="item.id" :label="item.name">{{item.name}}</el-option>
						</el-select>
					</el-form-item>
						
                    <el-form-item label="选择级别"  v-if="sInfo.isLevel" >
                        <el-select v-model="form.jobLevelId" style="width:600px;">
                            <el-option v-for="item in jbList" :key="item.id" :value="item.id" :label="item.name">{{item.name}}</el-option> 
                        </el-select>
                    </el-form-item>
					<!-- <el-form-item :label-width="formLabelWidth" label="供应商:" v-if="!ids">
						<el-col :span="10">
						<el-select clearable v-model="supplierId" placeholder="请选择供应商" style="margin-right:10px;"
						 :filterable="true"
						:remote="true" :remote-method="searchsupplier" 
							>
							<el-option clearable v-for="item in supplierList" :key="item.id" :label="item.supplierName"
								:value="item.id">
							</el-option>
						</el-select>
						</el-col>
					</el-form-item> -->
                    <el-form-item>
                        <el-button :loading="loadingEdit" type="primary" @click="toEdit()">提交</el-button>
                        <el-button @click="editDialogVisible = false">取 消</el-button>
                        <!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

        <!-- 重置密码 -->
        <el-dialog  title="重置密码" :visible.sync="resetPasswordVisible"  width="500px"
        :close-on-click-modal="false">
            <div class="app-container" style="padding-right:40px;">
                <el-form ref="form" :model="form" :rules="mainFormRules" label-width="120" size="medium">
                    <!-- <el-form-item :label-width="formLabelWidth" label="账号:">
                        <el-input v-model="form.username" placeholder="请输入账号" disabled/>
                    </el-form-item> -->

                    <el-form-item :label-width="formLabelWidth" label="新密码:">
                        <el-input v-model="form.password" placeholder="请输入新密码" show-password/>
                    </el-form-item>

                    <el-form-item :label-width="formLabelWidth" label="确认新密码:">
                         <el-input v-model="form.surePass" placeholder="请输入新密码" show-password/>
                    </el-form-item>

                    <el-form-item>
                        <el-button :loading="loadingReset" type="primary" @click="toReset()">提交</el-button>
                        <el-button @click="editDialogVisible = false">取 消</el-button>
                        <!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

        <!-- 授权 -->
        <el-dialog style="float:rigin" title="授权" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">

            <el-checkbox-group v-model="userDataList" v-for="(item,index) in userData" :key="index">
                <el-checkbox :key="index-1" :label="item.roleId">{{item.roleName}}</el-checkbox>
            </el-checkbox-group>


            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="insertRoleFun" :loading="insertRoleFunLoading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                roleData: [{}], //用户列表
                editDialogVisible: false,
				storeId:'',
                dialogVisible: false,
				supplierList:[],
                ids: '',//授权用户id
				supplierId:'',
                userData: [{}],//用户角色列表
                userDataList: [],//用户角色列表选中的
                formLabelWidth: "120px",
                page: { pageNum: 1, pageSize: 10 },
                form: {
                    username: "",
                    password: "",
                    surePass: ""
                },
                mainFormRules: {
                    username: { required: true, message: "请输入账号", trigger: "blur" },
                    password: { required: true, message: "请输入新密码", trigger: "blur" },
                    surePass: { required: true, message: "请输入新密码", trigger: "blur" },
                },
                titleName: "",
                supplierName:'',

                loadingEdit: false,

                sInfo:{},
                jbList: [],
                KxList: [],

                resetPasswordVisible: false,
                loadingReset: false,

                insertRoleFunLoading: false,
            };
        },

        methods: {
            postChange(e){
				this.sInfo=this.KxList.find(item=>item.id==e)
				this.$api.erpJobLevel(e).then(res=>{
					this.jbList=res.data
					// this.form.jobLevelId=res.data[0].id
				})
			},
			searchsupplier(e){
				this.supplierName=e
				this.getSupplier()
			},
            //编辑弹框
            editialogVisible(id) {
                this.form = {}
                if (id) {
                    //编辑
                    this.ids = id
                    this.titleName = "编辑"
                    // this.findSysUserById(id);
                    this.$api.getSysUserById(id).then((res) => {
                        res=JSON.parse(this.$decrypt(res.data))
                        // console.log('数据---', res.data)
                        if (res.state == 'success') {
                            this.form = res.data
                            if(res.data.isLevel){
                                this.sInfo.isLevel = true;
                                this.$api.erpJobLevel(res.data.jobId).then(res=>{
                                    this.jbList = res.data
                                    // this.form.jobLevelId=res.data[0].id
                                })
                            }
                        }
                    })
                } else {
                    this.ids = "";
                    this.sInfo = {};
                    this.titleName = "添加"
                }
                this.editDialogVisible = true;
            },
            resetPassword(id) {
                this.form = {}
                this.ids = id
                this.resetPasswordVisible = true;
            },
            findSysUserById(id) {
                this.$api.findSysUserById(id).then((res) => {
                    if (res.state == 'success') {
                        // console.log('数---', res.data)
                        this.form.username = res.data.username
                    }
                })
            },
            toReset(){
                //重置密码
                    if (this.form.password !== this.form.surePass) {
                        this.$message.error("两次密码不一致");
                        return false;
                    }
                    this.loadingReset = true;
                    let data = {
                        id: this.ids,
                        username: this.form.username,
                        password: this.form.password,
						supplierId: 0
                    }
                    this.$api.editSysUser(data).then((res) => {
                        if (res.state == 'success') {
                            this.$message({
                                message: res.message,
                                type: 'success'
                            });
                            this.editDialogVisible = false;
                            this.getUserList();
                        } else {
                            this.$message.error(res.message);
                        }
                        this.loadingReset = false;
                    })
            },
            toEdit() { //
                this.loadingEdit = true;
                if (this.ids) {
                    let data = {
                        id: this.ids,
                        username: this.form.username,
						phone: this.form.phone,
						realname: this.form.realname,
                        supplierId: 0,
                        erpJobUserDto:{
                            id: this.form.jobUserId,
                            jobId: this.form.jobId,
                            jobLevelId: this.form.jobLevelId,
                            isLevel: this.sInfo.isLevel
                        }
                    }
                    // console.log('shshs0--', data)
                    this.$api.editSysUserById(data).then((res) => {
                        if (res.state == 'success') {
                            this.$message({
                                message: res.message,
                                type: 'success'
                            });
                            this.editDialogVisible = false;
                            this.getUserList();
                        } else {
                            this.$message.error(res.message);
                        }
                        this.loadingEdit = false;
                    })
                } else {
                    //添加
                    let data = {
                        username: this.form.username,
                        password: this.form.password,
						phone: this.form.phone,
						realname: this.form.realname,
                        supplierId: 0,
                        erpJobUserDto:{
                            jobId: this.form.jobId,
                            jobLevelId: this.form.jobLevelId,
                            isLevel: this.sInfo.isLevel
                        }
                    }
                    this.$api.insertSysUser(data).then((res) => {
                        if (res.state == 'success') {
                            this.$message({
                                message: res.message,
                                type: 'success'
                            });
                            this.editDialogVisible = false;
                            this.getUserList();
                        } else {
                            this.$message.error(res.message);
                        }
                        this.loadingEdit = false;
                    })
                }
            },
            // 打开授权弹窗
            dialogVisibleFun(id) {
                this.userDataList = []
                this.ids = id
                this.dialogVisible = true;

                this.$api.findRoleByUserId(id).then((res) => {
                    if (res.state == 'success') {
                        var newArr = [] //需要展示的数据
                        // var item = ''
                        res.data.forEach(item => {
                            newArr.push(item.roleId)
                        });
                        this.userDataList = newArr//需要展示的数据
                    }
                })
                this.$api.queryManageRoleWhere().then((res) => {
					if (res.state == 'success') {
                        this.userData = res.data
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            //添加用户权限
            insertRoleFun() {
                this.insertRoleFunLoading = true
                let data = {
                    userId: this.ids,
                    roleIdArray: this.userDataList
                }
                this.$api.insertUserRole(data).then((res) => {
                    if (res.state == 'success') {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        });
                        this.getUserList();
                        this.dialogVisible = false;
                    } else {
                        this.$message.error(res.message);
                    }
                    
                    this.insertRoleFunLoading = false
                })
            },
            //删除角色
            toDeleteRole(id) {
                this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.deleteSysUser(id).then((res) => {
                        if (res.state == 'success') {
                            this.$message({
                                message: res.message,
                                type: 'success'
                            });
                            this.getUserList();
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            headClass() {
                return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
            },
            pageChange(data) {
                this.page.pageNum = data
                this.getUserList()
            },
            handleSizeChange(val) {
                this.page.pageSize = val
                this.getUserList()
            },
            formartDate(row, column) {
                var time = new Date(row.createDate);
                var ymdhis = "";
                ymdhis += time.getFullYear() + "-";
                ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
                ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
                ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
                ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
                ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
                return ymdhis;
            },
            getUserList() {
                this.loading = true
                let data = {
                    pageNum: this.page.pageNum,
                    pageSize: this.page.pageSize
                }
                this.$api.queryManageUserWhere(data).then((res) => { //用户管理列表
                    // console.log('用户管理列表:', res);
					// res=JSON.parse(this.$decrypt(res.data))
                    if (res.state == 'success') {
                        this.roleData = res.data
                        this.loading = false
                    }
                })
            },
			getSupplier(){
                let data = {
                    storeId:0,
                    supplierName:this.supplierName
                }
				this.$api.supplierNameList(data).then(res=>{
					// res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
                        this.supplierList=res.data
                    }else{
                        this.$message.error(res.message);
                    }
				})
			}
        },
        created() {
            this.getUserList();
            this.getSupplier()
            this.$api.getUserInfo(this.$encrypt({})).then(res => {
				res.data = JSON.parse(this.$decrypt(res.data)).data
				if (res.state == 'success') {
					// console.log('用户信息--', res.data)
					this.storeId = res.data.storeId
				}
			})
            // this.storeId=sessionStorage.getItem('storeId')
            
            this.$api.geterpJob().then(res=>{
				this.KxList=res.data
			})
        }
    };
</script>

<style>
</style>